export { default } from "bullitttime-embermodelsevent/models/segment";
